import React, { Component } from 'react'
import { Button, Icon } from 'antd'

class EventNotFound extends Component {
  render () {
    return (
      <div style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: 'calc(100vh - 69px - 100px - 20px)', marginTop: 100 }}>
        <Icon type="exclamation-circle" style={{ fontSize: '100px' }} />
        <h1 style={{ marginTop: '10px' }} >ขออภัย ไม่พบงานวิ่งนี้</h1>
        <Button type="ghost" onClick={() => window.history.back()} >ย้อนกลับ</Button>
      </div>
    )
  }
}

export default EventNotFound



// WEBPACK FOOTER //
// ./src/App/pages/Error/EventNotfound.js